(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacesheetSectionDialogController', FacesheetSectionDialogController);

    FacesheetSectionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FacesheetSection'];

    function FacesheetSectionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FacesheetSection) {
        var vm = this;

        vm.facesheetSection = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.facesheetSection.id !== null) {
                FacesheetSection.update(vm.facesheetSection, onSaveSuccess, onSaveError);
            } else {
                FacesheetSection.save(vm.facesheetSection, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:facesheetSectionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
